import { TextBody } from '@tkww/orion-web-ds-text';
import React from 'react';
import type { EstimateSourceType } from '../../../types';

const ESTIMATE_SOURCE_CLAUSE: Record<EstimateSourceType, string> = {
	vendor: 'data shared by the venue',
	market: 'market data',
	mix: 'venue and market data',
};

interface EstimateDisclaimerProps {
	estimateSourceType?: EstimateSourceType;
	className?: string;
}

export const EstimateDisclaimer = ({
	estimateSourceType = 'mix',
	className,
}: EstimateDisclaimerProps) => {
	const sourceClause = ESTIMATE_SOURCE_CLAUSE[estimateSourceType];

	return (
		<TextBody size="xs" asTyped color="subtle-dark" className={className}>
			{`* Estimate calculated by The Knot using ${sourceClause}. Final pricing, availability and included services may vary. Contact the venue for a quote.`}
		</TextBody>
	);
};
